<template>
    <div class="userCenter">
        <div class="layer">
            <Search />
        </div>
        <div class="layer">
            <SuperNav :list="data.headerNav" />
        </div>
        <div class="nav_bottom"></div>
        <div class="layer clearfix">
            <div class="fl mr15 mt20" style="width: 250px;">
                <NavLeft/>
            </div>
            <div class="fl">
                <router-view/>
            </div>
        </div>
    </div>
</template>

<script>
import Search from '@/components/Search/index.vue'
import NavLeft from '@/components/NavLeft/navLeft.vue'
import SuperNav from '@/components/SuperNav/index.vue'
export default {
    components: {NavLeft,Search,SuperNav},
    methods: {

    },
    computed: {
        data() {
            return this.$store.getters.shop_index
        }
    },
    mounted() {
        
    }
}

</script>

<style lang="scss" scoped>
    
</style>

<style lang="scss">
    .userCenter{
        .contentTitle{
            border: 1px solid #e3e2e1;
            border-bottom: none;
            font-weight: 700;
            height: 37px;
            line-height: 37px;
            text-indent: 1.5em;
        }
    } 
</style>